import { useFetchStepsQuery } from "../services/application";
import type { Step } from "../types/step";
import { useApplicationId } from "./useApplicationId";

// todo: default steps to empty array?
export const useSteps = () => {
	const applicationId = useApplicationId();
	const {
		data: steps,
		isError,
		isLoading,
		isFetching,
		refetch: refetchSteps,
	} = useFetchStepsQuery(applicationId);

	const areStepsCompleted = (...stepNames: Array<Step["name"]>) =>
		stepNames.every(
			(stepName) =>
				steps?.some((step) => step.name === stepName) &&
				steps // prettier-ignore
					?.filter((step) => step.name === stepName)
					.every((step) => step.status === "Completed"),
		);

	const someStepExists = (...stepNames: Array<Step["name"]>) =>
		stepNames.some((stepName) => steps?.some((step) => step.name === stepName));

	const areStepsCompletedIfExists = (...stepNames: Array<Step["name"]>) =>
		areStepsCompleted(...stepNames.filter((sn) => !!steps?.find((step) => step.name === sn)));

	return {
		areStepsCompletedIfExists,
		steps,
		isError,
		isLoading,
		isFetching,
		refetchSteps,
		someStepExists,
		areStepsCompleted,
	};
};
